import DeckGL from "deck.gl";
import type { DeckGLProps, MapView, MapViewState } from "deck.gl";
import "maplibre-gl/dist/maplibre-gl.css";
import { Map as MapGL } from "react-map-gl/maplibre";
import { maplibre } from "./_helpers/maplibre";
import "./deck-map.css";

interface DeckMapProps extends Omit<DeckGLProps<MapView>, "initialViewState" | "children"> {
  mapStyle: string;
  initialViewState: MapViewState;
}

export function DeckMap({ mapStyle, ...props }: DeckMapProps) {
  return (
    <div className="absolute inset-0">
      <DeckGL<MapView> {...props}>
        <MapGL mapLib={maplibre} mapStyle={mapStyle} attributionControl={{ compact: false }} />
      </DeckGL>
    </div>
  );
}
